import Cookies from 'js-cookie'

const setExpirationTime = (minutes) => {
  return new Date(new Date().getTime() + minutes * 60 * 1000);
};
export const cookieOption = {
  ...(process.env.COOKIE_SECURE && process.env.REACT_APP_COOKIE_SECURE !== 'false' ? { secure: true } : {}),
  ...(process.env.COOKIE_SAME_SITE ? { sameSite: process.env.REACT_APP_COOKIE_SAME_SITE } : { sameSite: 'Strict' })
}

export const setCookie = ({ name = '', value = '', addExpirationTime = false, expirationTime = 120 }) => {
  if (!name || !value) {
    console.log(`Invalid Cookie cookie name or value missing`)
    return
  }
  Cookies.set(name, value, {
    ...cookieOption,
    ...(addExpirationTime ? { expires: setExpirationTime(expirationTime) } : {}),
  })
}
